import { theme } from "common";
import { lighten } from "polished";
import styled from "styled-components";

const eBrandGoalType = {
  CLOSED: "Closed",
  OPEN: "Open",
  NEW: "New",
};

const eBrandGoalTypeDescription = {
  Closed: "Goals for Brands with No Open POs",
  Open: "Goals for Brands with Open POs",
  New: "New Goals",
};

const eBrandGoalTypeColor = {
  Closed: theme.colors.success,
  Open: theme.colors.primary,
  New: theme.colors.danger,
};

const eBrandGoalTypeDescriptionSingle = {
  Closed: "No Open POs",
  Open: "Open POs",
  New: "New",
};

const poStatuses = {
  AWAITING_ACKNOWLEDGE: "Awaiting Acknowledge",
  DRAFT: "Draft",
  NOT_RECEIVED: "Not Received",
  RECEIVED: "Received",
  VOID: "Void",
  PARTIAL_RECEIVED: "Partial Received",
};

const poStatusMap = {
  9: poStatuses.AWAITING_ACKNOWLEDGE,
  0: poStatuses.DRAFT,
  1: poStatuses.NOT_RECEIVED,
  7: poStatuses.RECEIVED,
  4: poStatuses.RECEIVED,
  8: poStatuses.VOID,
  2: poStatuses.PARTIAL_RECEIVED,
};

const isBrandOpen = (b = { purchaseOrders: [] }) => {
  const openPos = b.purchaseOrders.filter((po) =>
    [
      poStatuses.AWAITING_ACKNOWLEDGE,
      poStatuses.NOT_RECEIVED,
      poStatuses.PARTIAL_RECEIVED,
    ].includes(poStatusMap[po.Status])
  );
  return { openPos, isOpen: openPos.length > 0 };
};

const GoalChipContainer = styled.div`
  padding: 0.2rem;
  border-radius: 4px;
  font-weight: bold;
  background: ${({ color }) => lighten(0.39, color)};
  border: 2px solid ${({ color }) => color};
  font-size: 0.6rem;
`;

const GoalChip = ({ type }) => {
  return (
    <GoalChipContainer color={eBrandGoalTypeColor[type]}>
      {eBrandGoalTypeDescriptionSingle[type]}
    </GoalChipContainer>
  );
};

export {
  eBrandGoalType,
  eBrandGoalTypeDescription,
  eBrandGoalTypeDescriptionSingle,
  GoalChip,
  isBrandOpen,
  poStatusMap,
};
